import { useSnackbar } from "notistack";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useQuery } from "@tanstack/react-query";
import {
  ProgrammesList,
  RecordNotFound,
} from "../../components/_dashboard/programmes";
import { programmesListing } from "../../DAL/Programmes/Programmes";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function Programmes() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { contentSettingData } = useContentSetting();
  const {
    data: programmesData = [],
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["programmesList"],
    queryFn: async () => {
      const result = await programmesListing();
      if (result?.code !== 200) {
        throw new Error(result?.message);
      }
      return result;
    },
    select: (result) => {
      return (
        result?.program?.program?.filter((item) => item._id !== null) || []
      );
    },
    onError: (error) => {
      enqueueSnackbar(error?.message, { variant: "error" });
    },
  });

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-9 col-sm-12">
          {contentSettingData && contentSettingData.programs_description ? (
            <div
              className="dashboard_description"
              dangerouslySetInnerHTML={{
                __html: contentSettingData.programs_description,
              }}
            ></div>
          ) : (
            <h2>Programmes</h2>
          )}
        </div>
        <div className="col-lg-3 col-sm-12 text-end">
          {contentSettingData.program_button_text &&
            contentSettingData.program_button_link && (
              <button
                onClick={() => {
                  contentSettingData.program_button_link &&
                    window.open(
                      contentSettingData.program_button_link,
                      "_blank",
                    );
                }}
                className="small-contained-button mt-2"
              >
                {contentSettingData.program_button_text}
              </button>
            )}
        </div>
      </div>

      {programmesData.length > 0 ? (
        <>
          <ProgrammesList programmes={programmesData} reload={refetch} />
        </>
      ) : (
        <>
          <RecordNotFound title="Programmes" />
        </>
      )}
    </div>
  );
}
